export default function jsonStripFunctionsAndStringify(obj) {
  const seen = new WeakSet()

  try {
    return JSON.stringify(obj, (_, value) => {
      if (typeof value === 'function') {
        return undefined
      }
      if (typeof value === 'object' && value !== null) {
        if (seen.has(value)) {
          return '[Circular]'
        }
        seen.add(value)
      }
      return value
    })
  } catch {
    return '{}'
  }
}
